// Footer locale helpers.
//
// The sanctioned SiteFooter (@eventbrite/legacy-infra.site-footer) expects a full
// CoreEnv.localeInfo object (contact/social/help fields) + a sorted locale list for its
// language selector. eb-ui's <SiteStructure> got these from the Django-injected
// `env.localeInfo` / `env.locales`; in Valkyrie we build them from @eventbrite/webapp-locales.
//
// Extracted verbatim from the recipe proven inline in the 4 shipped chrome apps
// (trending-webapp src/lib/localeInfo.ts + Footer.tsx). Coalesces null/undefined -> ''
// so getServerSideProps props stay JSON-serializable (a stray undefined 500s the page).
import { getDefaults, getTldLocaleFromRequest, LOCALE_DEFAULTS, } from '@eventbrite/webapp-locales';
export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_LOCALE_UNDERSCORE = 'en_US';
/**
 * Build the CoreEnv.localeInfo object the SiteFooter needs, from webapp-locales getDefaults().
 * Coalesces the nullable link/social fields to '' so the result is JSON-serializable.
 */
export function createDefaultLocaleInfo(req) {
    const locale = req ? getTldLocaleFromRequest(req) : DEFAULT_LOCALE_UNDERSCORE;
    const defaults = getDefaults(locale);
    return {
        ...defaults,
        contact_us_path: defaults.contact_us_path ?? '',
        contact_us_url: defaults.contact_us_url ?? '',
        sales_contact_landing_page: defaults.sales_contact_landing_page ?? '',
        sales_contact_link_text: defaults.sales_contact_link_text ?? '',
        twitter_page: defaults.twitter_page ?? '',
        facebook_page: defaults.facebook_page ?? '',
        linked_in_page: defaults.linked_in_page ?? '',
        instagram_page: defaults.instagram_page ?? '',
        blog_url: defaults.blog_url ?? '',
        help_center_language: defaults.help_center_language ?? '',
    };
}
/** The footer language selector's option list, sorted by display name. */
export const LOCALE_LIST = LOCALE_DEFAULTS.map(({ locale, localized_language_name, locale_name }) => ({
    locale,
    localized_language_name,
    locale_name,
}))
    .slice()
    .sort((a, b) => a.locale_name.localeCompare(b.locale_name));
